import { render, staticRenderFns } from "./Treeselect2.vue?vue&type=template&id=a13f8916&"
import script from "./Treeselect2.vue?vue&type=script&lang=js&"
export * from "./Treeselect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports